import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { getCommonTealiumProps } from 'helpers/AccountHelper';
import { getSearch, setSearchData } from '../SearchActions';
import { scrollTop } from '../components/FindProcessor';

const useSearch = ({
  accessToken,
  deviceId,
  inputRef,
  searchCount,
  searchValue,
  setFetchingSearch,
  setSearchCompleted,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const searchDebounce = setTimeout(() => {
      scrollTop();

      if (searchValue) {
        const sanitizedInput = encodeURI(searchValue);
        getSearch({
          accessToken,
          deviceId,
          query: `${sanitizedInput}&includeRetired=true&itemsPerPage=25`,
          searchValue,
        }).then(data => {
          setFetchingSearch(false);
          setSearchCompleted(true);

          // checking the updated value for the input so that search data only updtes when ever there is value,
          // this is a edge case where user can enters something on the input and removes all the input suddenly, but till
          //  the time api call has been made, so we can only update the store if we have the value of the search input
          if (inputRef?.current?.value) {
            dispatch(setSearchData({ data }));
            handleAnalytics({
              event: Events.SEARCH_COMPLETED,
              payload: {
                page_search_term: searchValue,
                page_num_search_results: searchCount,
              },
              tealiumPayload: {
                ...getCommonTealiumProps(),
              },
            });
          }
        });
      }
    }, 500);
    return () => clearTimeout(searchDebounce);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchCount, searchValue]);
};

export default useSearch;
